import React from 'react';
import { Field } from 'formik';
import { connect } from 'react-redux';

import Select from 'components/common/form/Select';
import { getPhotoReportTypes } from 'constants/photoReports';
import { getPhotoReportSettings } from 'actions/asyncActions';

const PhotoReportFilter = ({ photoReportSettings }) => (
    <Field
        name='type'
        component={Select}
        placeholder='Тип отчета'
        options={getPhotoReportTypes(photoReportSettings)}
        allowClear={true}
        path='id' />
)

export default connect(state => ({
    photoReportSettings: getPhotoReportSettings.selectData(state),
}))(PhotoReportFilter);
